
export const Contribution = () => {


    return (
        <>
         <div className="container-fluid">
            <div className="row pb-5" >


                <div className="col-lg-12 text-center pb-5">
                    <h2 className=" mt-4 fw-bold">Contribution  </h2>
                    <div className="col-8 col-lg-3 mx-auto zoom-in-out-box2 ">
                        <hr />
                    </div>
                </div>

                <div className="col-12 px-lg-5">
                    <div className="p-lg-2 p-4  " style={{ textAlign: 'justify', }}>
                        <p> Fundamental Principle of Indemnity precludes the assured to profit out of his loss by arranging the over insurance by way of double insurance. Contribution arises when there are:
                        </p>
                        <ul className="px-5">
                            <li>Two or more policies of indemnity</li>
                            <li>A common subject matter</li>
                            <li>A common peril</li>
                            <li>A common interest</li>
                            <li>Each policy liable for loss</li>
                        </ul>
                        <p> Double insurance arises when the consignor arranges for the insurance on behalf of the consignee, and consignee already has cover the same consignment under the floater policy. </p>

                        <p> Insurance cover for transit of cargo provides for the incidental storage cover during the course of transit and the owner of the warehouse also covers the cargo lying in his warehouse during storage as a bailee of the cargo. </p>

                        <p> Non marine policies generally provide for the contribution clause in the policy contract which provides for the ratable proportion of the payment of the claim amount in the event of claim admissible under the policy. Fire policies contain the Marine Clause to deal with the double insurance mentioned as above.</p>
                        <p> Marine Insurance Policies which are subject to English Law and Practice are govern by Section 32 (Double Insurance) and Section 80 (Right of Contribution).
                        </p>
                    </div>
                </div>

                <div className="col-12 px-lg-5 mt-5 mt-lg-5 ">
                    <div className=" food_for_health" >
                        <div className="row px-lg-5 p-4">

                            <div className="col-12 col-lg-8 pt-lg-5" style={{ textAlign: 'justify', }}>
                                <p><b> Food for Thought:  </b></p>

                                <p>Does it make any difference in marine and non- marine insurance with application of above sections of Marine Insurance Act regarding the double insurance and contribution? (Section 84 (3) (f))</p>
                                <p> <i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    What are the methods of the calculation of the contribution?
                                </p>
                            </div>

                            <div className="col-12 col-lg-4 d-flex align-items-center justify-content-center">
                                <img src="Static/Assets/Img/questionary.png" className="questionery_img mx-auto" alt="" srcset="" />

                            </div>

                        </div>

                    </div>
                </div>

            </div>
            </div>
            {/* <Footer /> */}
            {/* </div>
            </div> */}
        </>
    )
}
